export default __webpack_public_path__ + "static/media/2221.6a6eb31d.png";